import React, { useRef, useMemo } from "react";
import Slider from "react-slick";
import { useNavigate } from "react-router-dom";
import {
  convertDateFormat,
  convertStringToArray,
  sanitizeString,
} from "../../Utils/utils";
import { useSelector } from "react-redux";
import { useLanguageTranslation } from "../../hooks/useLanguageTranslation";
import { useGetProtectedApiDataQuery } from "../../redux/services/apiSlice";
import { imageUrl } from "../../constants/constants";
import SliderNavigation from "../SliderNavigation";
import Loader from "../Loader";

const Events = () => {
  const navigate = useNavigate();
  const { getText } = useLanguageTranslation();

  const { languageType } = useSelector((state) => state.homeSlice);
  const {
    data: eventData = [],
    isLoading,
    isError,
  } = useGetProtectedApiDataQuery({ url: "event", lang: languageType });
  const slider = useRef();

  const transformedData = useMemo(() => {
    return eventData.map((item) => ({
      ...item,
      field_upload_image: convertStringToArray(item.field_upload_image),
    }));
  }, [eventData]);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
  };

  const next = () => {
    slider.current.slickNext();
  };
  const prev = () => {
    slider.current.slickPrev();
  };

  if (isLoading) {
    return <Loader />;
  }

  if (isError) {
    return <div>Error loading events</div>;
  }

  return (
    <div className="col-12 col-sm-12 col-md-4 col-lg-4 events-sec">
      <div className="title-sec">
        <h2>{getText("Events", "गतिविधियाँ")}</h2>
        <SliderNavigation slider={slider} section={"events"} />
      </div>
      <div id="events1" className="event">
        <Slider {...settings} ref={slider}>
          {transformedData.map((event, counter) => (
            <div
              className="card-sec"
              key={counter}
              onClick={() => {
                navigate(`/events-detail/${event.nid}`);
              }}
            >
              <div className="img-sec">
                <img
                  src={
                    event?.field_upload_image?.[0]?.file_path
                      ? imageUrl + event.field_upload_image[0].file_path
                      : `${process.env.REACT_APP_IMAGE_URL_FRONTEND}/images/dummy.png`
                  }
                  alt={event.title}
                />
              </div>
              <div className="desc-sec">
                {event.field_ordering_date && (
                  <span className="date">{event.field_ordering_date}</span>
                )}
                <p className="line-clamp line-clamp-2">
                  {sanitizeString(event.title)}
                </p>
              </div>
            </div>
          ))}
        </Slider>
      </div>

      <a
        href="#"
        onClick={(e) => {
          e.preventDefault();
          navigate("/events-detail");
        }}
        className="quick-btn"
        aria-label={"View all events"}
      >
        {getText("View All", "सभी देखें")}
      </a>
    </div>
  );
};

export default Events;
